import React, { useState } from 'react';
import { View, Pressable } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';

import { Text, Title } from 'app/src/styles';
import { Actions, Action, ActionText } from 'app/src/styles/table';

import NewUser from './new';
import EditUser from './edit';
import { USERS, DESTROY_USER } from './queries';

const COLUMNS = [
  {
    key: 'id',
    label: 'ID',
  },
  {
    key: 'name',
    label: 'User name',
    sort: 'asc',
  },
  {
    key: 'displayName',
    label: 'Display name',
  },
  {
    key: 'project',
    label: 'Project',
    value: ({ value }) => value.name,
  },
  {
    key: 'emails',
    label: 'Emails',
    value: ({ value }) => value.join(', ')
  },
  {
    key: 'actions',
    label: 'Actions',
    sort: 'prevent',
    content: () => '',
  },
];

const Users = () => {
  const [showNew, setShowNew] = useState();
  const [showEdit, setShowEdit] = useState();

  const { data, refetch } = useQuery(USERS);

  const [destroyUser] = useMutation(DESTROY_USER, {
    onCompleted: () => refetch()
  });

  const confirmDestroy = user => {
    const confirmation = `Really destroy ${user.emails}?`;

    if (window.confirm(confirmation)) {
      destroyUser({ variables: { id: user.id } });
    }
  };

  const columns = [...COLUMNS];

  columns[columns.length - 1].content = ({ entry }) => (
    <Actions style={{ flexWrap: 'no-wrap' }}>
      <Action first>
        <Pressable onPress={() => setShowEdit(entry)}>
          <ActionText>Edit</ActionText>
        </Pressable>
      </Action>

      <Action>
        <Pressable onPress={() => confirmDestroy(entry)}>
          <ActionText>Destroy</ActionText>
        </Pressable>
      </Action>
    </Actions>
  );

  return (
    <View>
      <Title>Email Address</Title>

      <Pressable onPress={() => setShowNew({})}>
        <Text>Add Email</Text>
      </Pressable>

      {data && (
        <DataTable.Simple
          data={data.users}
          columns={columns}
          pageLength="All"
          htmlTable
        />
      )}

      {showNew && (
        <NewUser
          setShow={setShowNew}
          refetch={refetch}
          projects={data.projects}
        />
      )}

      {showEdit && (
        <EditUser
          user={showEdit}
          setShow={setShowEdit}
          refetch={refetch}
          projects={data.projects}
        />
      )}
    </View>
  );
};

export default Users;
